import React, { Component } from 'react';
import { connect } from 'react-redux';
import CommitteeButton from './committee-button';
import ShowMeetings from './committee-show-meetings';
import CommitteeColleagues from './committee-colleagues';
import { isUserLoggedIn, showCommitteeMeetings } from '../actions';
import '../global';

class CommitteeBox extends Component {

	isPartOfCommittee() {
		let ccode = this.props.committee.code;
		let myCommittees = this.props.myCommittees;
		if ( myCommittees.includes( ccode ) ) {
			return true;
		} else {
			return false;
		}
	}

	getStaffContact( emailObj, contact, partOfCommittee ) {
		let contactHtml = contact;
		let email = (typeof emailObj.props !== 'undefined') ? emailObj.props['data-email']  : '';
		if ( email !== '' && partOfCommittee ) {
			let mailTo = 'mailto:' + email;
			contactHtml = (
				<a className='email-active' data-email={ email } data-ccode={ this.props.committee.code } href={ mailTo }><span className="glyphicon glyphicon-envelope" aria-hidden="true" />{ contact }
				</a>
			);
		}
		return (
			<p className="staff-contacts">
				{ contactHtml }
			</p>
		);
	}



	render() {
		let myCommittees = this.props.myCommittees;
		let requestedCommittees = this.props.requestedCommittees;
		let committee = this.props.committee;
		let partOfCommittee = (typeof this.props.is_part_of_committee === 'undefined'
		                      )
			? this.isPartOfCommittee()
			: this.props.is_part_of_committee;
		let errorMessage = '';
		let emailAddress = (committee.emailContact !== ''
		                   ) ? (
			                   <a className={ 'staff-email-link' } data-email={ committee.emailContact } href={ `mailto:${committee.emailContact}` }><i className="glyphicon glyphicon-envelope contact-email"></i></a>
		                   ) : '';
		if ( !is_member() && !(myCommittees.includes( committee.code ) || requestedCommittees.includes( committee.code )
			) && committee.openToNonMembers !== '1' && isUserLoggedIn() ) {
			errorMessage = (
				<p className="members-only-message"><span className="glyphicon glyphicon-info-sign" aria-hidden="true" />Available for <a href="/membership/application/" target="_blank">Members Only</a></p>
			);
			emailAddress = '';
		}

		// if(!isUserLoggedIn()){
		// 	errorMessage = (
		// 		<p className="members-only-message"><span className="glyphicon glyphicon-info-sign" aria-hidden="true" /><a href={ get_home_page_url() + '/my-account?redirect_to=/committees' }>Login to Join</a></p>
		// 	);
		// 	emailAddress = '';
		// }

		return (

			<div className="committee-box" key={ committee.id }>
				<span className="committee-subcategory">{ committee.policyGroup }  |  { committee.type }</span>
				<h3 className="committee-title">{ committee.title }</h3>
				<p className="committee-desc">{ committee.description }</p>
				<hr className="contact-divider"></hr>
				<div className="committee-details">
					<div className="committee-contacts">
						<p className="committee-contacts-title">ISDA Staff Contacts:
							<span className="sr-only">for { committee.title }</span>
						</p>
						{ this.getStaffContact( emailAddress, committee.contact, partOfCommittee ) }
					</div>
					<input type="hidden" value={ committee.type } />

					<ShowMeetings ccode={ committee.code } />
					{ (partOfCommittee
					  ) && <div className="committee-options-container">
						  <CommitteeColleagues ccode={ committee.code } email={ committee.emailContact } />
					  </div> }

				</div>
				<div className="join-committee-btn-wrapper">
				<CommitteeButton committee={ committee } />

					<div className="help-block with-errors">
							{ errorMessage }
						</div>

				</div>
			</div>
		);
	}
}

function mapStateToProps( { committees, myCommittees, requestedCommittees } ) {
	return {
		committees, myCommittees, requestedCommittees
	};
}

export default connect( mapStateToProps )( CommitteeBox );